import dayjs from 'dayjs';

const months = [
  'Jan',
  'Feb',
  'Mar',
  'Apr',
  'May',
  'June',
  'July',
  'Aug',
  'Sept',
  'Oct',
  'Nov',
  'Dec',
];

export const formatMonthDate = (year, month) => {
  if (!month) return '';
  const monthIndex = months.indexOf(month) + 1;
  const monthString = monthIndex < 10 ? `0${monthIndex}` : `${monthIndex}`;
  return `${year}-${monthString}-01`;
};

export const toDateOnly = date =>
  dayjs(date)
    .startOf('day')
    .toDate();

/**
 * Formats an estimated availability date.
 * Dates that fall on a Monday are prefixed with "w/c" (week commencing).
 *
 * @param {string|Date} date
 * @returns {string}
 */
export const formatEstimatedDate = date => {
  const d = dayjs(date);
  return d.day() === 1
    ? `w/c ${d.format('DD MMM YYYY')}`
    : d.format('DD MMM YYYY');
};
